import React, { Component } from 'react'
import { ManageUsers } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as usersActionCreators from '../../redux/modules/users'
import { db } from '../../config/firebaseconfig'


class ManageUsersContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      inputSelection: ' ',
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    db.collection('users').get()
      .then((querySnapshot) => {
        let users = []
        querySnapshot.forEach( (doc) => {
          users.push(doc.data())
        })
        this.props.fetchingAllUsersSuccess(users)

      })
      .catch((error) => this.props.fetchingAllUsersError(error))

    
    
  }

  handleChange(e) {
    this.setState({inputSelection: e.target.value})
  }

  handleSubmit () {
    if (this.state.inputSelection === ' ') {
      this.props.setUserDevOnly(
        '',
        '',
        '',
        null
      )
    } else {
      let activeUser
      this.props.usersList.forEach((user) => {
        if (user.uid === this.state.inputSelection) {
          activeUser = user
        }
      })
      this.props.setUserDevOnly(
        activeUser.uid,
        activeUser.email,
        activeUser.role,
        activeUser
      )
    }
  }

  render() {
    return (
      <ManageUsers
        isFetchingAllUsers={this.props.isFetchingAllUsers}
        usersList={this.props.usersList}
        error={this.props.error}
        activeUserId={this.props.activeUserId}
        setUserDevOnly={this.props.setUserDevOnly}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        testUserRole={this.props.testUser ? this.props.testUser.role : ''}
        setTestUser={this.props.setTestUser}
      />
     )
  }
}

export default connect(
  (state) => ({
    isFetchingAllUsers: state.users.isFetchingAllUsers,
    usersList: state.users.usersList,
    error: state.users.error,
    activeUserId: state.users.uid,
    testUser: state.users.testUser,
  }),
  (dispatch) => bindActionCreators(usersActionCreators, dispatch)
)(ManageUsersContainer)


// WEBPACK FOOTER //
// ./src/containers/Users/ManageUsersContainer.js